import { mc } from '@lss/common/game/characters/MC';
import Game from '../../src/shell/Game';
import ImageClass from "../../src/shell/Image";
import Question from '../../src/shell/Questions';
import { jump } from '../../src/shell/jump';
import { chris } from '../characters/Chris';
import { jenny } from '../characters/Jenny';
import { joe } from '../characters/Joe';
import { merry } from '../characters/Merry';
import { images } from "./images";
import { V5AfterBeachJoeyOrEmily, V5EmilyNight } from './V5';
import { V6ChrisMerryEnd } from './V6_ChrisMerry';
import { doTransition } from '../helpers/helpers';

export const JoeyBeach1 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeCar_0, { transition: true });
    joe.talk(`I'm glad you joined! It's fun to have a partner.`);
    joe.talk(`Sometimes I enjoy being alone, but there are times that I've been missing the company.`);
    mc.talk(`Glad to be here!`);
    mc.talk(`But I usually get bored really fast, I hope it won't be the case.`);
    joe.talk(`No way man! I brought tons of beers, how can it be boring? Haha.`);
    mc.talk(`Solid point, haha.`);
    return jump(JoeyBeach2, "JoeyBeach2");
};
export const JoeyBeach2 = async (): Promise<any> => {
    doTransition(images.v5.JoeBeach_0, { transition: true });
    joe.talk(`Here we are!`);
    mc.talk(`It's nice having a beach so close to home.`);
    joe.talk(`Yes! I love it! Too bad we didn't appreciate it sooner.`);
    mc.talk(`So, Joey, how's life?`);
    joe.talk(`Hold on for a minute! We are missing something.`);
    ImageClass.setImage(images.v5.JoeBeach_1);
    joe.talk(`These bad boys.`);
    ImageClass.setImage(images.v5.JoeBeach_3);
    mc.talk(`Woah, who is going to drink all of these?`);
    joe.talk(`Haha, I always bring extra, I never know how long I'm going to stay here.`);
    ImageClass.setImage(images.v5.JoeBeach_4);
    joe.talk(`There you go.`);
    ImageClass.setImage(images.v5.JoeBeach_5);

    mc.talk(`Thanks.`);
    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`Now, what were you saying?`);
    ImageClass.setImage(images.v5.JoeBeach_7);
    mc.talk(`Nothing specific, just wondering what's going on with you right now.`);
    mc.talk(`We finished school a year ago, what are your plans for the future?`);
    ImageClass.setImage(images.v5.JoeBeach_8);
    mc.talk(`I'm asking because I sit at home like a bum.`);

    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`It's funny that you ask because I was thinking about that lately.`);
    joe.talk(`I really have no idea what I'm going to do with my life.`);
    ImageClass.setImage(images.v5.JoeBeach_8);
    joe.talk(`First of all, I should get a job and fast because I'm running out of money.`);
    joe.talk(`It's not like before when I used to stay at home and I had no expenses.`);
    ImageClass.setImage(images.v5.JoeBeach_7);
    mc.talk(`Wow, Joey is talking about a job. Who knew those days would come.`);
    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`Haha, the same goes for you.`);
    mc.talk(`Do you have anything specific in mind?`);
    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`Not really, I thought of asking around the gym if they need personal trainers or something I dunno.`);
    joe.talk(`Or maybe I can ask Chris if they need a bartender, that job seems really cool.`);
    joe.talk(`A job with unlimited alcohol, chicks that are talking to you and you don't need to wake up early in the morning.`);
    mc.talk(`It does sound very tempting.`);
    joe.talk(`Why not go for it?`);
    mc.talk(`I never really thought about it. But I might!`);
    joe.talk(`You should talk to Chris, maybe he can arrange something.`);
    mc.talk(`We'll see.`);

    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`By the way, I almost forgot to ask, but why did Emily get back home?`);
    ImageClass.setImage(images.v5.JoeBeach_7);
    mc.talk(`I have no idea, I didn't have the chance to talk to her, you saw her before I did.`);
    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`I know I've said it but that's crazy she came back.`);
    joe.talk(`I remember when she left, she wanted to be independent and live by her own terms.`);
    mc.talk(`I'll have a chat with her, and I'm sure she will explain everything.`);
    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`Don't forget to tell me!`);
    mc.talk(`I won't.`);


    return jump(JoeyBeach3, "JoeyBeach3");
};

export const JoeyBeach3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_8);
    mc.talk(`What about you and Vanessa?`);
    if (Question.globalAnswers.v4ToldJoeyToTurnAround) {
        mc.talk(`Are you ok after yesterday?`);
        ImageClass.setImage(images.v5.JoeBeach_6);
        joe.talk(`Are you talking about that guy yesterday?`);
        mc.talk(`Yeah...`);
        joe.talk(`We are fine, people hit on her all the time.`);
        joe.talk(`I'm sure she didn't mean to do anything with him anyway. You know how she is like.`);
    } else {
        ImageClass.setImage(images.v5.JoeBeach_6);
        joe.talk(`Everything is great.`);
        mc.think(`He doesn't know...`);
    }

    ImageClass.setImage(images.v5.JoeBeach_8);
    joe.talk(`But there is this one thing.`);
    joe.talk(`Like I've told you before, when it comes to sex, Vanessa and I have done everything already.`);
    joe.talk(`So we thought about ways to spice up our relationship even further.`);
    joe.talk(`I suggested that we should add another girl.`);
    mc.talk(`Damn, nice, what did she say?`);
    joe.talk(`Haha, what do you think? She agreed on the spot.`);
    mc.talk(`NICE!`);
    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`Haha, yeah, thanks.`);
    ImageClass.setImage(images.v5.JoeBeach_8);
    joe.talk(`But there is one catch.`);
    joe.talk(`She said that if she agreed for a two girls threesome we should do a two guys threesome afterward...`);
    mc.talk(`Damn...`);
    mc.talk(`But why though?\nI don't want to sound rude, but I believe she's had a threesome before.`);
    joe.talk(`You aren't... I agree. I believe she's had one. But she wasn't in a serious relationship before.`);
    mc.think(`Serious...`);
    mc.talk(`Did you agree?`);
    ImageClass.setImage(images.v5.JoeBeach_9);
    joe.talk(`I said that I will think about it.`);
    joe.talk(`You know, it's not something you just agree to on right away.`);
    joe.talk(`My dick wants to say yes but my mind wants to say no.`);
    joe.talk(`What do you think about that?`);
    return jump(JoeyBeach3_2, "JoeyBeach3_2");
};

export const JoeyBeach3_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_9);
    mc.think(`Damn, who's that girl in the back?`);
    ImageClass.setImage(images.v5.JoeBeach_10);
    joe.talk(`Yo, are you listening to me?`);
    mc.talk(`Sorry, got distracted by this hot chick.\nDon't look right now, but she is right behind you.`);
    ImageClass.setImage(images.v5.JoeBeach_11, { wait: true });
    ImageClass.setImage(images.v5.JoeBeach_12);
    joe.talk(`She's hot!`);
    mc.talk(`I told you not to look.`);
    joe.talk(`I'm glad I did.\nShe is smoking!`);
    joe.talk(`Do you still see her? Where did she sit?`);
    mc.talk(`She is just standing there, staring at me.`);
    ImageClass.setImage(images.v5.JoeBeach_13);
    mc.talk(`I think she is coming over.`);
    await joe.talk(`Really? You are like a lucky charm. Haha.`);
    ImageClass.setImage(images.v5.JoeBeach_14);
    await jenny.set((properties) => {
        jenny.name = "Beach Girl";
    });

    jenny.talk(`Excuse me.`);
    mc.talk(`Yes?`);
    jenny.talk(`Can I lay here?`);
    mc.talk(`You should ask him, that's his chair...`);
    ImageClass.setImage(images.v5.JoeBeach_15);
    jenny.talk(`Can I?`);
    joe.talk(`You can, only if it doesn't bother you that I'm going to sit here as well.`);
    jenny.talk(`That's not a problem, thanks.`);


    return jump(JoeyBeach3_3, "JoeyBeach3_3");
};

export const JoeyBeach3_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_16);
    mc.talk(`So where were we?`);
    ImageClass.setImage(images.v5.JoeBeach_18);
    joe.talk(`Maybe we should continue our conversation some other time.`);
    ImageClass.setImage(images.v5.JoeBeach_17);
    mc.talk(`Nah.`);
    ImageClass.setImage(images.v5.JoeBeach_20);
    mc.talk(`She is wearing headphones. Just talk.`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_18);
    joe.talk(`Ok, so what would you do regarding my dilemma?`, { method: "Whispering" });
    return jump(JoeyBeach3_Question, "JoeyBeach3_Question");

};

export const JoeyBeach3_Question = async (): Promise<any> => {

    ImageClass.setImage(images.v5.JoeBeach_18);
    await joe.setQuestion(new Question({ text: `So, what would you do?`, options: { think: false, array: "v5JoeyBeachThreeSomeQuestionArr" }, key: `v5JoeyBeachThreeSomeQuestion` })
        .option({ title: `I would agree`, key: `IWouldAgree` })
        .option({ title: `I wouldn't agree`, key: `IWouldDisagree` })
        .option({ title: `Remind me of the question again`, key: `remindMe`, hide: Question.globalAnswers.v5JoeyBeachThreeSomeQuestionArr?.includes('remindMe') }));


    if (Question.globalAnswers.v5JoeyBeachThreeSomeQuestion === "IWouldAgree") {

        return jump(JoeyBeach3_Agree, "JoeyBeach3_Agree");
    } else if (Question.globalAnswers.v5JoeyBeachThreeSomeQuestion === "IWouldDisagree") {

        return jump(JoeyBeach3_Disagree, "JoeyBeach3_Disagree");
    } else {

        return jump(JoeyBeach3_Remind, "JoeyBeach3_Remind");
    }
};
export const JoeyBeach3_Remind = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_18);
    mc.talk(`Remind me of the question again`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_21);
    joe.talk(`Ahh...`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_18);
    joe.talk(`What would you do if you were me, with Vanessa?`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_17);
    mc.talk(`Do what?`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_18);
    joe.talk(`You know... The thing.`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_17);
    mc.talk(`I don't understand.`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_17);
    joe.talk(`Alright, fuck it I'll repeat it.`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_18);
    joe.talk(`Let's say your girlfriend said that for you to have a threesome with two girls, you will need to do a two men threesome afterward.`, { method: "Whispering" });
    return jump(JoeyBeach3_Question, "JoeyBeach3_Question");
};

export const JoeyBeach3_Agree = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_17);
    mc.talk(`I would agree.`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_23);
    joe.talk(`Really?`, { method: "Whispering" });
    mc.talk(`Sure, why not?`, { method: "Whispering" });
    joe.talk(`Wouldn't you mind another guy fucking your girl?`, { method: "Whispering" });
    mc.talk(`I'd be fucking another girl in another occasion, so why not?`, { method: "Whispering" });
    joe.talk(`Mmm... I guess.`, { method: "Whispering" });

    return jump(JoeyBeach4, "JoeyBeach4");
};


export const JoeyBeach3_Disagree = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_17);
    mc.talk(`I wouldn't agree.`, { method: "Whispering" });
    ImageClass.setImage(images.v5.JoeBeach_18);
    joe.talk(`That's what I thought. But don't you want to be with two girls at the same time?`, { method: "Whispering" });
    mc.talk(`I do, but I don't want someone to fuck my girl.`, { method: "Whispering" });
    joe.talk(`That's exactly my point.`, { method: "Whispering" });
    return jump(JoeyBeach4, "JoeyBeach4");
};


export const JoeyBeach4 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_17);
    mc.talk(`Did my answer help you?`);
    joe.talk(`Mmm... I'll have to think about that more.`);
    joe.talk(`I'll ask some guys at the gym... We'll see.`);
    mc.talk(`Good luck dude.`);
    ImageClass.setImage(images.v5.JoeBeach_21);
    joe.talk(`Thanks man.`);
    ImageClass.setImage(images.v5.JoeBeach_22);
    joe.talk(`Give me one minute, I need to pee.`);
    ImageClass.setImage(images.v5.JoeBeach_24);
    return jump(JoeyBeach4_questions, "JoeyBeach4_questions");
};

export const JoeyBeach4_questions = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_24);
    await mc.setQuestion(new Question({ text: `Joey left.`, options: { think: true }, key: `v5JoeyBeachMadeJennyAngry` })
        .option({ title: `Hey`, key: false })
        .option({ title: `You have nice boobs`, key: true }));


    if (Question.globalAnswers.v5JoeyBeachMadeJennyAngry) {
        await mc.set((properties) => {
            properties.jennyRelationship--;
        });
        return jump(JoeyBeach4_TalkRude, "JoeyBeach4_TalkRude");

    }
    await mc.set((properties) => {
        properties.jennyRelationship++;
    });
    return jump(JoeyBeach4_Talk, "JoeyBeach4_Talk");
};

export const JoeyBeach4_Talk = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_25, { duration: 0.6 });
    mc.talk(`Hey.`);
    mc.talk(`...`);
    mc.talk(`HEY.`);
    ImageClass.setImage(images.v5.JoeBeach_26);
    jenny.talk(`Are you talking to me?`);
    mc.talk(`I am.`);
    ImageClass.setImage(images.v5.JoeBeach_27);
    jenny.talk(`Didn't hear you, the volume was loud.`);
    await mc.talk(`You were lying here next to us and we don't even know your name.`);
    await jenny.set((properties) => {
        jenny.name = "Jenny";
    });
    jenny.talk(`My name is Jenny...`);
    mc.talk(`I'm ${mc.name}.`);
    jenny.talk(`Hi.`);
    mc.talk(`What are you listening to?`);
    jenny.talk(`Just mainstream, nothing specific.`);
    if (Question.globalAnswers.v5JoeyBeachThreeSomeQuestionArr?.includes("remindMe")) {

        jenny.talk(`Well, you kinda made your friend talk, so yeah, how could I not?`);
    } else {

        mc.talk(`So you heard nothing?`);
        jenny.talk(`I'd be lying if I said that I didn't turn off the music at one point because I was curious to hear what you are talking about.`);
        mc.talk(`How much did you hear?`);
        jenny.talk(`Enough.`);
    }
    mc.talk(`Since you are up to date, what do you think?`);
    ImageClass.setImage(images.v5.JoeBeach_28, { duration: 0.6 });
    jenny.talk(`I usually don't talk about these kind of stuff with a guy I don't know.`);
    ImageClass.setImage(images.v5.JoeBeach_50);
    jenny.talk(`But I did interrupt you in your conversation.`);
    ImageClass.setImage(images.v5.JoeBeach_28);

    jenny.talk(`So my answer is: Depends on how much I love him.`);
    ImageClass.setImage(images.v5.JoeBeach_49);
    jenny.talk(`It really depends if I'd be jealous enough to enjoy the moment.`);
    ImageClass.setImage(images.v5.JoeBeach_50);
    jenny.talk(`But on the other hand, I don't want to prevent him from enjoying all the joys in life.`);
    ImageClass.setImage(images.v5.JoeBeach_28);
    jenny.talk(`And it also depends if I want to try it enough myself that I'd agree to let him do it too.`);
    ImageClass.setImage(images.v5.JoeBeach_49);
    jenny.talk(`Well, it's really complicated, I need to think this through.`);
    mc.talk(`I was expecting a yes or no answer.`);
    return jump(JoeyBeach4_Question, "JoeyBeach4_Question");
};

export const JoeyBeach4_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_28);
    await jenny.setQuestion(new Question({ text: `That's what happens when you ask a girl a complicated question. Haha.`, options: { think: false }, key: `v5JoeyBeachFlirtedWithJenny` })
        .option({ title: `Flirt with her`, key: true })
        .option({ title: `Don't flirt`, key: false }));


    if (Question.globalAnswers.v5JoeyBeachFlirtedWithJenny) {

        return jump(JoeyBeach4_Flirt, "JoeyBeach4_Flirt");
    } else {

        return jump(JoeyBeach4_DontFlirt, "JoeyBeach4_DontFlirt");
    }
};

export const JoeyBeach4_Flirt = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_28);
    await mc.set((properties) => {
        properties.jennyRelationship += 2;
    });
    mc.talk(`That's the longest that I've talked to a girl without having some eye contact.`);
    jenny.talk(`Oh.`);
    ImageClass.setImage(images.v5.JoeBeach_29);
    jenny.talk(`Haha.`);
    jenny.talk(`Sorry, the sun was in my eyes and they have corrective lenses so I'd be basically blind without them.`);
    mc.talk(`You have beautiful eyes!`);
    jenny.talk(`Thank you!`);
    jenny.talk(`By the way, they are brown not black like everyone seems to think.`);
    mc.talk(`Of course they are black.`);
    jenny.talk(`They are not!`);
    ImageClass.setImage(images.v5.JoeBeach_30, { duration: 0.6 });
    jenny.talk(`Look, brown.`);
    jenny.talk(`Do you see?`);
    mc.talk(`I see them alright.`);
    ImageClass.setImage(images.v5.JoeBeach_31);
    jenny.talk(`Good!`);
    mc.think(`Who cares about her eyes when I have those boobs almost in my face.`);
    ImageClass.setImage(images.v5.JoeBeach_32);
    jenny.talk(`You must have a thing for eyes, haha!`);
    ImageClass.setImage(images.v5.JoeBeach_33);
    mc.talk(`Yeah... Especially when they are big like yours.`);
    ImageClass.setImage(images.v5.JoeBeach_29);
    jenny.talk(`Haha, stop it!`);

    return jump(JoeyBeach5, "JoeyBeach5");
};
export const JoeyBeach4_DontFlirt = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_28);
    mc.talk(`So what are you doing here all by yourself?`);
    jenny.talk(`I always come alone.`);
    jenny.talk(`I love to listen to music and watch the ocean.`);
    mc.talk(`Do you do that often?`);
    jenny.talk(`Yes, but not on this beach, I usually  go to the northern one.`);
    mc.talk(`Why, do you live far away?`);
    jenny.talk(`Not really, I just want to avoid people I know.`);
    mc.talk(`Got it.`);
    jenny.talk(`What about you? Do you come here often?`);
    mc.talk(`To be honest, not so much.`);
    return jump(JoeyBeach5, "JoeyBeach5");
};


export const JoeyBeach5 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_39);
    joe.talk(`Oh, hey there.`);
    jenny.talk(`Hey!`);
    mc.talk(`Joe, that's Jenny.`);
    joe.talk(`Pleased to meet you.`);
    jenny.talk(`Thanks, me too.`);
    ImageClass.setImage(images.v5.JoeBeach_40);
    joe.talk(`What were you talking about before I came? Summarize it for me.`);
    if (mc.properties.jennyRelationship >= 2) {

        mc.talk(`You've missed a lot.`);
        mc.talk(`She agreed to show me something I've been dying to see.`);
        mc.talk(`And yes! They are really big!`);
        ImageClass.setImage(images.v5.JoeBeach_42);
        jenny.talk(`Haha! I know what you are trying to do!`);
        ImageClass.setImage(images.v5.JoeBeach_41);
        jenny.talk(`He is talking about my eyes.`);
        joe.talk(`I didn't think otherwise.`);
    } else {

        mc.talk(`You didn't miss much, we were just talking.`);
        joe.talk(`Oh, ok.`);
    }

    return jump(JoeyBeach5_Question, "JoeyBeach5_Question");
};

export const JoeyBeach5_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_40);
    await jenny.setQuestion(new Question({ text: `Anyway, it was fun, I'm gonna get going.`, options: { think: false }, key: `v5JoeyBeachTookJennysNumber` })
        .option({ title: `Ask for her number`, key: true })
        .option({ title: `Say goodbye`, key: false }));


    if (Question.globalAnswers.v5JoeyBeachTookJennysNumber) {
        await mc.set((properties) => {
            properties.hasJennysNumber = true;
        });

        return jump(JoeyBeach5_Number, "JoeyBeach5_Number");
    } else {

        await mc.set((properties) => {
            properties.hasJennysNumber = false;
        });

        return jump(JoeyBeach5_GoodBye, "JoeyBeach5_GoodBye");
    }

};


export const JoeyBeach5_Number = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_40);
    mc.talk(`You can't just leave without giving me your number.`);
    jenny.talk(`Mmm...`);
    jenny.talk(`I don't usually do this... But maybe you can give me yours.`);
    mc.talk(`I know that trick, you ain't gonna call.`);
    jenny.talk(`You might be surprised.`);
    jenny.talk(`Sec.`);
    ImageClass.setImage(images.v5.JoeBeach_43);
    jenny.talk(`Let me just grab my bag.`);
    mc.think(`Damn.`);
    ImageClass.setImage(images.v5.JoeBeach_44);
    jenny.talk(`One more second.`);
    ImageClass.setImage(images.v5.JoeBeach_45);
    jenny.talk(`Ok, so what is it?`);
    ImageClass.setImage(images.v5.JoeBeach_46);
    mc.talk(`91-2123-344.`);
    jenny.talk(`Got it.`);
    ImageClass.setImage(images.v5.JoeBeach_47);
    jenny.talk(`Bye guys, it was fun!`);

    return jump(JoeyBeach6, "JoeyBeach6");
};


export const JoeyBeach5_GoodBye = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_40);
    mc.talk(`Bye Jenny.`);
    jenny.talk(`Bye guys, it was fun!`);
    joe.talk(`Bye Jenny.`);
    return jump(JoeyBeach6, "JoeyBeach6");
};


export const JoeyBeach6 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_48);
    mc.think(`There she goes...`);
    mc.think(`Joey couldn't have been more obvious.`);
    ImageClass.setImage(images.v5.JoeBeach_6);
    joe.talk(`Damn man!`);
    joe.talk(`That's a fine piece of ass.`);
    if (Question.globalAnswers.v5JoeyBeachTookJennysNumber) {
        joe.talk(`Here I was thinking I can give you tips.`);
        joe.talk(`I'd be lying if I said I'm not jealous.`);
        if (mc.properties.annStatus === "gf") {

            ImageClass.setImage(images.v5.JoeBeach_8);
            joe.talk(`What about Ann though?`);
            mc.talk(`Do you really think she is gonna call?`);
            joe.talk(`She might.`);
        }

        ImageClass.setImage(images.v5.JoeBeach_8);
        mc.talk(`We'll see.`);
        mc.talk(`She could have taken my number just because she is too nice to say no.`);
        ImageClass.setImage(images.v5.JoeBeach_6);
        joe.talk(`Nah, no way. She was totally into you.`);
        mc.talk(`You think?`);
        joe.talk(`Damn right!\nI saw the chemistry.`);
        mc.talk(`Time will tell.`);

    } else {
        ImageClass.setImage(images.v5.JoeBeach_6);
        joe.talk(`She was totally into you! You should have asked her for her number!`);
        mc.talk(`You think?`);
        joe.talk(`Positive!`);
        mc.talk(`It's too late now.`);
        joe.talk(`You can't know, you might see her again.`);
        mc.talk(`I might, we'll see.`);
    }

    return jump(V5AfterBeachJoeyFinish, "V5AfterBeachJoeyFinish");
};

export const JoeyBeach4_TalkRude = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_25);

    mc.talk(`You have nice boobs.`);
    mc.think(`...`);
    mc.talk(`NICE BOOBS.`);
    ImageClass.setImage(images.v5.JoeBeach_34);
    jenny.talk(`EXCUSE ME?`);
    mc.think(`Now she heard me.`);
    mc.talk(`I was just admiring the view.`);
    ImageClass.setImage(images.v5.JoeBeach_35);
    mc.think(`She didn't like that.`);
    ImageClass.setImage(images.v5.JoeBeach_36);
    mc.talk(`I was joking.`);
    ImageClass.setImage(images.v5.JoeBeach_37, { transition: true });
    joe.talk(`Where is the chick?`);
    ImageClass.setImage(images.v5.JoeBeach_38);
    mc.talk(`She left.`);
    joe.talk(`Already? She just got here.`);
    mc.talk(`I maybe said something that made her split...`);
    joe.talk(`Oh no...`);
    joe.talk(`Damn bro, that's bad, she was extremely hot.`);
    mc.talk(`Nothing to do about that now.`);
    joe.talk(`Yeah...`);
    return jump(V5AfterBeachJoeyFinish, "V5AfterBeachJoeyFinish");
};

export const V5AfterBeachJoeyFinish = async (): Promise<any> => {
    ImageClass.setImage(images.v5.JoeBeach_8);
    if (Game.seenScenarios.includes(`AnnAfterTODNotLove2`) &&
        Question.globalAnswers.v25JoeTODAgree &&
        Question.globalAnswers.v1AllowChrisGetAnnsNumber === false) {
        joe.talk(`But I do have a confession before we go.`);
        mc.talk(`A confession?`);
        joe.talk(`Yes.`);
        joe.talk(`If you remember, I first met Ann at the truth or dare game.`);
        joe.talk(`I dared her to kiss me and stuff right?`);
        mc.talk(`I remember.`);
        joe.talk(`So she kept texting me the next day.`);
        joe.talk(`Bro, she wants my dick so hard.`);
        mc.talk(`What did she say?`);

        joe.talk(`She didn't say it straight forward.`);
        joe.talk(`But she wrote something like: "I had a great time, I'd like to do that again".`);
        mc.talk(`What did you say?`);
        joe.talk(`I gave her a simple answer, I couldn't show like I was interested.\nShe is Vanessa's best friend.`);
        joe.talk(`I'm not stupid. It can easily be a test.`);
        mc.talk(`If you didn't do anything, and nothing happened, what's the confession?`);
        joe.talk(`Because I keep thinking about that.`);
        joe.talk(`I really want to fuck her bro.`);
        if (mc.properties.annLateHate) {
            joe.talk(`Back at the gym you said that you changed your mind about her... And you are interested in her.`);
            joe.talk(`But to be honest bro, I think that ship has sailed...`);
        }
        mc.talk(`What about Vanessa?`);
        joe.talk(`She won't find out.`);
        mc.talk(`Bold statement. Ann can easily say something.`);
        joe.talk(`I believe she won't.`);
        mc.talk(`What can I say? It looks like you have a plan in mind already.`);
        joe.talk(`I'm not going to do anything just yet. Just thinking about that.`);
        if (Game.seenScenarios.includes(`ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar`)) {
            mc.talk(`Before you do anything there is something you should know.`);
            joe.talk(`What?`);
            mc.talk(`I saw her in the car with Chris.`);
            mc.talk(`She was sucking his dick.`);
            joe.talk(`ANN? No way.`);
            mc.talk(`She did.`);
            joe.talk(`Damn... Going all out.`);
            mc.talk(`Does it change anything?`);
            joe.talk(`Not really, haha.`);
            joe.talk(`Vanessa told me she isn't like that, that's why it's weird for me.`);
            mc.talk(`Maybe she got sick of being shy sweet and naive.`);
            joe.talk(`Maybe.`);
        }

        joe.talk(`Anyway...`);

    } else {

    }
    mc.talk(`I think it's time to go home.`);
    joe.talk(`I agree.`);
    joe.talk(`We should do this more often!`);
    mc.talk(`Sure, why not.`);
    joe.talk(`Great!`);
    return jump(V5AfterBeachJoeyOrEmily, "V5AfterBeachJoeyOrEmily");
};